import { controls, grouped } from "../../controls";
import moment from "moment";

const enreport = {
  label: "Empty Names Report",
  starting: true,
  url: "enreport",
  pageLabel: "Empty Names Report",
  pageType: "history",
  filter: [
    ...controls.magicDateLabel({ label: "As On Date", width: "col-sm-1", target: "as_on_date" }),
    ...controls.magicDate({ dateType: "ontype", isRequired: true, name: "as_on_date", width: "col-sm-2" }),
    ...controls.magicDateLabel({ label: "", width: "col-sm-2" }),

   ...grouped.iterative("advance")

  ],
  form: [],

  history: {
    perPage: 10,
    reportHeader: "Empty Names Report",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: false,
    textReportProps: {
      'Recon': {
        filename: `"Empty_Names_Report$pageData.as_on_date$O-01.RC`,
        format: {}
      },
    },
    displayColumns: [
      {
        Header: "name",
        accessor: "name",

      },
      {
        Header: "Mothers Name",
        accessor: "mothers_name",
  
      },
      {
        Header: "Fathers Name",
        accessor: "fathers_name",

      },
      {
        Header: "Village/Ward",
        accessor: "village_ward",

      },
         {
        Header: "Taluka",
        accessor: "taluka",

      },
      
    ]
  }
};

export default enreport;